import { render, staticRenderFns } from "./timer.vue?vue&type=template&id=2106bcb8&"
import script from "./timer.vue?vue&type=script&lang=ts&"
export * from "./timer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports